import React from 'react';
import Page from '../components/Page';

interface PrivacyPolicyProps { }

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = () => {
    return (
        <Page title="PrivacyPolicy" heading="Privacy policy">
            <div className="inner-container">
                <div className="white-card">
                    <div className="white-card-content">
                        <h3 className="section-title">Cookie & Storage Policy</h3>
                        <p>
                            This policy explains how SpeechBox uses cookies and similar technologies to recognize you when you visit our application. It explains what these technologies are and why we use them, as well as your rights to control our use of them.
                        </p>

                        <h3 className="section-title">What are cookies and local storage?</h3>
                        <p>
                            Cookies are small data files that are placed on your computer or mobile device when you visit a website. Local storage is a similar technology that stores data on your browser but with some technical differences. SpeechBox uses both cookies and local storage technologies.
                        </p>

                        <h3 className="section-title">Why do we use these technologies?</h3>
                        <p>
                            We use cookies and local storage for several reasons:
                        </p>
                        <ul>
                            <li><strong>Essential:</strong> These are necessary for the application to function properly. They enable basic functions like authentication, security, and storing your recordings.</li>
                            <li><strong>Preferences:</strong> These allow us to remember choices you make and provide enhanced functionality and personalization.</li>
                            <li><strong>Analytics:</strong> These help us understand how you interact with the application so we can improve it.</li>
                        </ul>

                        <h3 className="section-title">What specific storage do we use?</h3>
                        <p>
                            SpeechBox uses the following storage mechanisms:
                        </p>
                        <ul>
                            <li><strong>LocalStorage:</strong> Used to store authentication tokens and user preferences</li>
                            <li><strong>IndexedDB:</strong> Used to store audio recordings and activity data temporarily before uploading</li>
                            <li><strong>Google Analytics:</strong> Used to collect anonymous usage statistics to improve the application</li>
                        </ul>

                        <h3 className="section-title">How can you control your cookie preferences?</h3>
                        <p>
                            When you first visit SpeechBox, you will be presented with a cookie consent banner where you can choose which types of cookies you accept. You can change your preferences at any time by visiting the Privacy Settings section in your account page.
                        </p>

                        <h3 className="section-title">What happens if you disable cookies?</h3>
                        <p>
                            If you disable essential cookies/storage, certain parts of the application will not function properly. If you disable non-essential cookies, certain features like personalization may not be available.</p>
                    </div>
                </div>
                <div className="spacer-40" />
            </div>
        </Page>
    );
};

export default PrivacyPolicy;